<template>
  <el-dialog :model-value="modelValue" :title="title" :width="width" :show-close="showClose" :modal="true"
    :close-on-click-modal="closeOnClickModal" :close-on-press-escape="closeOnPressEscape" :custom-class="customClass"
    align-center @close="handleClose" @update:modelValue="$emit('update:modelValue', $event)"
    style="padding: 0; border-radius: 8px; --el-dialog-padding-primary: 0" append-to-body>
    <template #default>
      <slot />
    </template>
    <template v-if="$slots.footer" #footer>
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script setup>

const props = defineProps({
  modelValue: { type: Boolean, required: true },
  title: { type: String, default: "" },
  width: { type: String, default: "324" },
  showClose: { type: Boolean, default: false },
  closeOnClickModal: { type: Boolean, default: true },
  closeOnPressEscape: { type: Boolean, default: true },
  customClass: { type: String, default: "" },
});

const emit = defineEmits(["update:modelValue", "close"]);

console.log("addressShow", props.modelValue);

function handleClose() {
  emit("update:modelValue", false);
  emit("close");
}
</script>

<style></style>
